/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type ISaasEscrowsQueryVariables = Types.Exact<{
  order?: Types.InputMaybe<Types.QueryOrderEnum>;
  escrowParty?: Types.InputMaybe<Types.EscrowPartyTypeEnum>;
  status?: Types.InputMaybe<Types.EscrowStatusFilterEnum>;
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  perPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  query?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type ISaasEscrowsQuery = {
  __typename?: 'Query';
  saasEscrows: {
    __typename?: 'SaasEscrowPage';
    nodesCount: number;
    pagesCount: number;
    nodes: Array<{
      __typename?: 'SaasEscrow';
      id: string;
      changesRequested: boolean;
      status: Types.EscrowStatusEnum;
      createdAt: any;
      adminReviewAt?: any | null;
      onboardingAt?: any | null;
      signedAt?: any | null;
      activatedAt?: any | null;
      certificationVerified: boolean;
      certificationCertified: boolean;
      userUpdatedAt: any;
      pendingActivation: boolean;
      lastDeposit?: any | null;
      agreement: {
        __typename?: 'Agreement';
        id: string;
        agreementForm?: Types.AgreementFormEnum | null;
        approved: boolean;
      };
      escrowInvitation?: {
        __typename?: 'EscrowInvitation';
        id: string;
        status: Types.InvitationStatusEnum;
        partyType: string;
        companyName: string;
        escrow:
          | { __typename?: 'ContinuityEscrow'; id: string }
          | { __typename?: 'SaasEscrow'; id: string }
          | { __typename?: 'SoftwareEscrow'; id: string };
        policy: { __typename?: 'EscrowInvitationPolicy'; accept: boolean };
      } | null;
      escrowTermination?: {
        __typename?: 'EscrowTermination';
        status: Types.EscrowTerminationStatusEnum;
        terminateAt?: any | null;
      } | null;
      beneficiary?: {
        __typename?: 'Beneficiary';
        id: string;
        companyName?: string | null;
        companyWebsite?: string | null;
      } | null;
      depositor?: {
        __typename?: 'Depositor';
        id: string;
        companyName?: string | null;
        companyWebsite?: string | null;
      } | null;
      policy: { __typename?: 'SoftwareEscrowPolicy'; remove: boolean };
    }>;
  };
};

export const SaasEscrowsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'saasEscrows' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'QueryOrderEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'escrowParty' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EscrowPartyTypeEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EscrowStatusFilterEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saasEscrows' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'escrowParty' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'escrowParty' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perPage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SaasEscrowBaseFields' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nodesCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pagesCount' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SaasEscrowBaseFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SaasEscrow' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'changesRequested' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'agreement' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agreementForm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'approved' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'escrowInvitation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'partyType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'escrow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'policy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'accept' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'escrowTermination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'terminateAt' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'beneficiary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyWebsite' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'depositor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyWebsite' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'remove' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'adminReviewAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'onboardingAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'activatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'certificationVerified' } },
          { kind: 'Field', name: { kind: 'Name', value: 'certificationCertified' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userUpdatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pendingActivation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastDeposit' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ISaasEscrowsQuery, ISaasEscrowsQueryVariables>;
